import { useState } from "react";
import { useModal } from "context";
import { useTranslation } from "react-i18next";
import { FormButton, MessageBox } from "reusableComponents";

import styles from "./styles.module.scss";

const ReusableConfirmationModal = ({
  message,
  onConfirm,
  onCancel = () => {},
  confirmText,
  cancelText,
  loading: externalLoading = false,
  error: externalError = null,
}) => {
  const { closeModal } = useModal();
  const { t } = useTranslation("global");
  const [internalLoading, setInternalLoading] = useState(false);
  const [internalError, setInternalError] = useState(null);

  const confirmButtonLabel = confirmText || t("buttons.confirm");
  const cancelButtonLabel = cancelText || t("buttons.close");
  const isLoading = externalLoading || internalLoading;
  const error = externalError || internalError;

  const handleConfirm = async () => {
    if (typeof onConfirm !== "function") {
      closeModal();
      return;
    }

    setInternalLoading(true);
    setInternalError(null);
    
    try {
      await onConfirm();
      // Don't close modal here - let the parent component handle it after successful API call
    } catch (err) {
      const errorMessage = err.message || t("errors.genericError");
      setInternalError(errorMessage);
    } finally {
      setInternalLoading(false);
    }
  };

  const handleCancel = () => {
    onCancel();
    closeModal();
  };

  return (
    <div className={`${styles.deleteCardConfirmationModal} ${isLoading ? styles.loading : ""}`}>
      <p dangerouslySetInnerHTML={{ __html: message }} />
      {error && <MessageBox message={error} type="error" />}
      <div className={styles.buttons}>
      
        <FormButton
          variant="submit"
          onClick={handleConfirm}
          disabled={isLoading}
          label={confirmButtonLabel}
          loading={isLoading}
        />
          <FormButton
          variant="gray"
          onClick={handleCancel}
          label={cancelButtonLabel}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default ReusableConfirmationModal;


